export const KNOWN_PAGE_ROUTES = {
  1: '/Udesh',
  2: '/Contact',
  3: '/Cometee',
}

export function pagePath(page) {
  if (!page) return '/'
  const id = Number(page.page_id)
  if (KNOWN_PAGE_ROUTES[id]) return KNOWN_PAGE_ROUTES[id]
  return `/page/${id}`
}

export function sortMenuPages(pages) {
  return [...(pages || [])].sort((a, b) => {
    const seqA = Number(a.menu_sequence) || 0
    const seqB = Number(b.menu_sequence) || 0
    if (seqA !== seqB) return seqA - seqB
    return (Number(a.page_id) || 0) - (Number(b.page_id) || 0)
  })
}

/** Published CMS pages are public by default; Inactive is the hide flag. */
export function isPageActive(page) {
  if (!page) return false
  const status = page.status
  if (status == null || status === '') return true
  if (Number(status) === 1) return true
  if (Number(status) === 0) return false
  const normalized = String(status).trim().toLowerCase()
  if (normalized === 'active') return true
  if (normalized === 'inactive') return false
  return true
}

export function pagesToMenuItems(pages) {
  return sortMenuPages((pages || []).filter(isPageActive)).map((page) => ({
    label: page.title,
    url: pagePath(page),
    open_new_tab: 0,
  }))
}

function normalizeMenuUrlKey(url) {
  const href = menuHref(url)
  if (isExternalUrl(href)) return href.replace(/\/$/, '').toLowerCase()
  const path = href.replace(/\/$/, '') || '/'
  return path.toLowerCase()
}

/**
 * Keep configured menu_items first; append Active CMS pages that are not
 * already linked (by URL). Does not mutate or replace menu_items.
 */
export function mergeMenuWithCmsPages(menuItems, pages) {
  const base = Array.isArray(menuItems) ? [...menuItems] : []
  const seen = new Set(base.map((item) => normalizeMenuUrlKey(item.url)))
  for (const item of pagesToMenuItems(pages)) {
    const key = normalizeMenuUrlKey(item.url)
    if (seen.has(key)) continue
    base.push(item)
    seen.add(key)
  }
  return base
}

/** Hardcoded header links used when menu API has no active items. */
export const DEFAULT_HEADER_MENU = [
  { label: 'मुख्य पृष्ठ', url: '/' },
  { label: 'ऑनलाइन दान', url: '/Donation' },
  { label: 'गौ शाला मदत', url: '/Help' },
  { label: 'गैलरी', url: '/Gallary' },
]

export function isExternalUrl(url) {
  return /^https?:\/\//i.test(String(url || '').trim())
}

/** Normalize stored menu URL for React Router Link (internal paths). */
export function menuHref(url) {
  const raw = String(url || '').trim()
  if (!raw) return '/'
  if (isExternalUrl(raw)) return raw
  if (raw.startsWith('/')) return raw
  return `/${raw}`
}
